export default __webpack_public_path__ + "static/media/pending.417e3996.svg";